import { Layout } from "antd";
import styled from "styled-components";

const Content = styled.div`
  min-height: 100vh;
  padding: 16px 24px;
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  @media (max-width: 400px) {
    padding: 16px 0px;
  }
`;

export const GuestLayout = ({ title, children }: any) => {
  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        <Content>{children}</Content>
      </Layout>
    </>
  );
};
